<template>
    <modal :show="show"
        :title="modalTitle"
        :saveButton="{title: 'Ok', btnClass: {'btn btn-main btn-rounded btn-sm z-depth-0': true, 'disabled': !this.input}}"
        :cancelButton="{title: 'Cancelar', btnClass: {'btn btn-outline-main btn-rounded btn-outline btn-sm z-depth-0': true}}"
        size="small"
        :needHeader="false"
        :relativeBackdrop="true"
        :contentCentered="true"
        class="modal-prompt"
        @close="closeModal"
        @save="submitDialogForm"
    >
        <form class="dg-form"
              autocomplete="off"
              @submit.prevent="submitDialogForm"
        >
            <label for="dg-input-elem">{{ promptHelpText }}</label>
            <input type="text"
                    placeholder=""
                    v-model.trim="input"
                    autocomplete="off"
                    id="dg-input-elem"
                    ref="inputElem"
                    style="width: 100%;margin-top: 10px;
                        padding: 5px 15px; font-size: 16px;
                        border-radius: 4px; border: 2px solid #eee"
            />
        </form>
    </modal>
</template>

<script>
import Modal from './Modal';
export default {
    name: 'ModalPrompt',
    components: { Modal },
    props: {
        title: {
            type: String,
        },
    },
    data() {
        return {
            show: false,
            input: '',
            itemId: null,
            modalTitle: null,
            promptHelp: '',
            callback: null,
            itemData: null,
        }
    },
    mounted() {
        this.modalTitle = this.title;
        // this.$refs.inputElem && this.$refs.inputElem.focus();
    },
    computed: {
        promptHelpText () {
            return this.promptHelp
                .replace(/\[\+:(\w+)]/g, (match, $1) => {
                    return match
                })
        }
    },
    methods: {
        open: function(func, itemId, text, itemData, title=null) {
            this.input = null;
            this.show=true;
            this.itemId = itemId
            this.promptHelp = text;
            this.callback = func;
            this.itemData = itemData || null;
            if(title){
                this.modalTitle = title;
            }
        },
        closeModal: function() {
            this.show=false;
        },
        submitDialogForm () {
            this.proceed(this.getDefaultData());
        },
        getDefaultData () {
            return this.input;
        },
        proceed (withData = null) {
            this.callback(this.itemId, withData, this.itemData);
            this.closeModal();
        },

    }
}
</script>